import {Component, Input, OnChanges, SimpleChanges} from "@angular/core";
import {ResourceRequestListService} from "../../../feature/resource-request-list/services/resource-request-list.service";
import {AbstractStringAutocomplete} from "./abstract-string-autocomplete";
import {MessageService} from "src/app/core/services/services/message.service";
import {AlertEnum} from "src/app/core/models/Enums/AlertEnum";
import {MatProgressBar} from "@angular/material/progress-bar";
import {MatAutocomplete, MatOption} from "@angular/material/autocomplete";
import {NgClass, AsyncPipe} from "@angular/common";
import {MatPseudoCheckbox} from "@angular/material/core";
import {TranslatePipe} from "@ngx-translate/core";

@Component({
	selector: "app-client-autocomplete",
	templateUrl: "./autocomplete.component.html",
	styleUrls: ["./autocomplete.component.scss"],
	imports: [MatProgressBar, MatAutocomplete, MatOption, NgClass, MatPseudoCheckbox, AsyncPipe, TranslatePipe],
})
export class ClientAutocompleteComponent extends AbstractStringAutocomplete implements OnChanges {
	@Input() multiSelect: boolean = false;
	@Input() filterBusinessUnit: string | undefined;

	private _filterBusinessUnit?: string;

	constructor(
		private _resourceRequestListService: ResourceRequestListService,
		private messageService: MessageService,
	) {
		super();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes["filterBusinessUnit"] && this.filterBusinessUnit) {
			this._filterBusinessUnit = this.filterBusinessUnit;
			this.initialize();
		}
	}

	async fetchElements(): Promise<string[]> {
		if (!this._filterBusinessUnit) {
			return await this._resourceRequestListService.getResourceRequestClients().toPromise();
		}
		try {
			const result = await this._resourceRequestListService
				.getClientsByBusinessUnit(this._filterBusinessUnit)
				.toPromise();
			return result || [];
		} catch (error) {
			this.messageService.add(
				"Failed to load clients for Business Unit: " + this._filterBusinessUnit,
				AlertEnum.DANGER,
			);
			return [];
		}
	}
}

